import { 
  REQUEST_SHIPPING_RATE, 
  RECEIVE_SHIPPING_RATE,
  FAIL_SHIPPING_RATE, 
  CLEAR_SHIPPING_RATE,
} from "../actions/shippingRate";
import { 
  ADD_CART_ITEM, 
  ADD_CART_ITEMS,
  EDIT_CART_ITEM,
  REMOVE_CART_ITEM,
  CLEAR_CART, 
} from "../actions/cart";
import { actionTypes } from 'redux-form';

export default function shippingRate(state = {
  loading: false,
  loaded: false,
  item: null,
  dirty: false,
  alert: null,
}, action) {
  switch (action.type) {
    case CLEAR_SHIPPING_RATE:
      return {
        ...state,
        loading: false,
        loaded: false,
        item: null,
        alert: null
      };
    case REQUEST_SHIPPING_RATE:
      return {
        ...state,
        loading: true,
        dirty: false,
        alert: null
      };
    case RECEIVE_SHIPPING_RATE:
      return {
        ...state,
        loading: false,
        loaded: true,
        item: action.payload.item,
        lastUpdated: action.payload.receivedAt,
      };
    case FAIL_SHIPPING_RATE:
      return {
        ...state,
        loading: false,
        item: null,
      };
    case ADD_CART_ITEM: 
    case ADD_CART_ITEMS:
    case EDIT_CART_ITEM:
    case REMOVE_CART_ITEM:
    case CLEAR_CART:
      return {
        ...state,
        dirty: true
      }
    case actionTypes.CHANGE:
      if (action.meta && action.meta.form === "shipping") {
        if (action.meta.field === "country" || action.meta.field === "postCode") {
          return {
            ...state,
            dirty: true
          }
        }
      }
      return state;
    default:
      return state;
  }
}